<template>
  <!-- exhibition-activity .ep -->
  <div class="ecb">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>我的云店</BreadcrumbItem>
          <BreadcrumbItem>活动计划</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.name}}</div>
        <p class="header-tool-text" style="font-weight:bold;color:#b10042;">重要提示：此部分活动信息将于中国国际焙烤展移动端小程序与PC端同步显示，供观众查询使用</p> 
        <Input
          search
          placeholder="请输入关键字"
          v-model="searchField"
          @on-search="searchPro()"
          v-if="String(showTabs) === '1'"
          style="width:230px;margin-top:20px;"
        />
      </div>
      <div v-show="String(showTabs) === '1'" class="header-tool-box">
        <div class="htb-item" @click="$router.push('/exhibition/index/activity/addpro')">
          <span class="htb-add">+</span>
          <span>添加活动</span>
        </div>
      </div> 
    </div>
    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="活动" name="1">
          <exhibitionActivityItem
            ref="exhibitionActivityItem"
            v-if="String(showTabs) === '1'"
            :searchField="searchField"
          />
        </TabPane>
        <TabPane label="留言" name="2">
          <exhibitionActivityMes ref="exhibitionActivityMes" v-if="String(showTabs) === '2'" />
        </TabPane> 
      </Tabs>
    </div> 
    <Contact />
  </div>
</template>

<script>
import exhibitionActivityItem from "./../../subpages/exhibition-activity-item/exhibition-activity-item.vue";
import exhibitionActivityMes from "./../../subpages/exhibition-activity-mes/exhibition-activity-mes.vue"; 

import Contact from "@components/Contact/Contact";
import { mapGetters } from "vuex";

export default {
  name: "exhibition-business",
  data() {
    return {
      addBrandflag: false,
      showTabs: "1",
      searchField: "" // 搜索关键字
    };
  },
  components: { 
    exhibitionActivityItem,
    exhibitionActivityMes,
    Contact
  },
  created() {
    this.changeTab();
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition"
    }),
    query() {
      return this.$route.query;
    }
  },
  methods: { 
    searchPro() {
      this.$refs.exhibitionActivityItem.init();
    },
    changeTab() {
      if (this.query && this.query.type && this.query.type === "all") {
        this.showTabs = "1"; 
      } else if (this.query && this.query.type && this.query.type === "mes") {
        this.showTabs = "2";
      } 
    },
    switchBrand(name) {
      if (name === "1") {
        this.$router.push(`${this.$route.path}?type=all`);
      } else if (name === "2") {
        this.$router.push(`${this.$route.path}?type=mes`);
      } 
    }, 
  }
};
</script>

<style scoped lang="scss">
.eb-top-r {
  height: 100%;
  display: flex;
  align-items: flex-end;
  padding-bottom: 15px;
  &-box {
    width: 148px;
    height: 78px;
    border: 1px dashed #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: 0.5s;
    &:hover {
      border: 1px dashed #1890ff;
      transition: 0.5s;
    }
    .I1 {
      font-size: 16px;
      font-weight: bold;
      color: #1890ff;
    }
    .s3 {
      font-size: 14px;
      color: #1890ff;
      margin-left: 9px;
    }
  }
}
</style>
